export default "__VITE_ASSET__Cadqg37a__"